import plLocale from 'element-ui/lib/locale/lang/pl';
import countries from './pl/countries';

export default {
  test: 'Test PL',
  search: 'Szukaj...',
  backend: {
    errors: {
      40003: 'Brak dostępu do wykonywanej operacji',
      41012: 'Limit zainstalowanych urządzeń został już osiągnięty',
      41015: 'Podane hasło jest nieprawidłowe',
      41017: 'Niepoprawny prefix numeru telefonu',
      41018: 'Nazwa konta jest wymaga',
      42000: 'Podany email jest niepoprawny',
      42004: 'Użytkownik już istnieje',
      42005: 'Login lub hasło jest nieprawidłowe',
      42010: 'Niepoprawny lub zużyty link do resetowania hasła',
      42016: 'Niepoprawny token',
      42019: 'Podane hasło jest nieprawidłowe',
      43000: 'Urządzenie zostało już wcześniej zarejestrowane',
      44000: 'Zły format numeru telefonu',
      45000: 'Kontakt nie istnieje',
    },
  },
  general: {
    save: 'Zapisz',
    accountNotConfirmed: `Twoje konto nie zostało potwierdzone - kliknij w link wysłany do Ciebie w wiadomości e-mail,
      aby potwierdzić konto. W przeciwnym razie, po 30 dniach konto zostanie zablokowane`,
    goToSettings: 'Przejdź do ustawień',
    sendMailAgain: 'Wyślij e-mail ponownie',
    mailSent: 'Wiadomość została wysłana - sprawdź swoją skrzynkę email',
    confirmYourAccount: 'Potwierdź swoje konto',
    personalDataNotFilled: `Prosimy wypełnić dane osobowe powiązane z kontem -
      są one potrzebne do utworzenia poprawnego rachunku/faktury za usługę`,
    fillPersonalData: 'Wypełnij swoje dane osobowe',
    clickToCopy: 'Kliknij, aby skopiować wartość',
    delete: 'Usuń',
    edit: 'Edytuj',
    back: 'Powrót',
    refreshData: 'Odśwież dane',
    yes: 'Tak',
    no: 'Nie',
    actions: 'Akcje',
    close: 'Zamknij',
    subscriptionNearEnd: 'Ważność subskrybcji niedługo dobiega końca',
    subscriptionEnded: 'Ważność subskrybcji dobiegła końca. Do czasu przedłużenia subskrybcji korzystanie z aplikacji będzie niemożliwe',
  },
  menu: {
    dashboard: 'Dashboard',
    billing: 'Dane do faktury',
    suggestions: 'Wskazówki',
    settings: 'Ustawienia',
    logout: 'Wyloguj',
    devices: 'Urządzenia',
    apiKeys: 'Klucze API',
    contact: 'Kontakt',
    profile: 'Profil',
    integrations: 'Integracje',
    plan: 'Plan',
    callHistory: 'Historia połączeń',
    properties: 'Właściwości',
    records: 'Wyszukaj kontakt',
    paymentSettings: 'Ustawienia płatności',
    invoices: 'Faktury',
    help: 'Pomoc',
  },
  forms: {
    phone: 'Numer telefonu',
    phoneCode: 'Kod kraju',
    required: 'To pole jest wymagane',
    wrongPhone: 'Nieprawidłowy numer telefonu',
    wrongUrl: 'Niepoprawny format adresu url (poprawny to na przykład https://labelcall.com)',
    missingField: 'Brakująca wartość dla pola \'{field}\'',
    acceptTerms: 'Musisz zaakceptować wymagane zgody, aby kontynuować',
    options: {
      langs: countries,
      currencies: {
        PLN: 'Polski złoty (PLN)',
        EUR: 'Euro (EUR)',
        USD: 'Dolar amerykański (USD)',
        GBP: 'Funt brytyjski (GBP)',
      },
      currenciesSuffix: {
        PLN: 'zł',
        EUR: '€',
        USD: '$',
        GBP: '£',
      },
    },
    error: 'Błąd: {msg}',
    invalidEmail: 'Wprowadź adres e-mail w prawidłowym formacie',
    optional: '(opcjonalny)',
    passwordsNotMatch: 'Podane hasła nie są takie same',
    passwordPolicy: 'Hasło powinno mieć minimalnie 8 znaków, zawierać małą i dużą literę, cyfrę, oraz znak specjalny',
  },
  login: {
    title: 'Zaloguj się do Labelcall',
    email: 'Adres e-mail',
    password: 'Hasło',
    login: 'Zaloguj',
    forgotPassword: 'Zapomniałem hasła',
    dontHaveAccount: 'Nie masz konta?',
    register: 'Zarejestruj się',
    invalidUserNameOrPassword: 'Niepoprawny e-mail lub hasło',
  },
  register: {
    success: 'Konto zostało utworzone pomyślnie',
    title: 'Aby się zarejestrować wypełnij formularz poniżej',
    accountType: {
      personal: 'Konto osobiste',
      business: 'Konto firmowe',
    },
    email: 'Adres e-mail',
    password: 'Hasło',
    phone: 'Numer telefonu',
    locale: 'Język',
    confirmPassword: 'Powtórz hasło',
    backToLogin: 'Powrót do logowania',
    register: 'Zarejestruj',
    termsOfService1: 'Zgadzam się na ',
    marketingConsent: "Wyrażam zgodę na przetwarzanie moich danych osobowych przez Labelcall dla potrzeb realizacji zamówienia i marketingu",
    newsletterConsent: "Wyrażam zgodę na otrzymywanie Newslettera na podany adres e-mail",
  },
  logout: {
    success: 'Użytkownik wylogowany pomyślnie',
  },
  languagePicker: {
    pl: 'Polski',
    en: 'English',
  },
  profileDropdown: {
    myProfile: 'Mój profil',
    logout: 'Wyloguj',
    licenseDaysLeft: '{daysLeft} dni do końca licencji',
  },
  typePicker: {
    line: 'Wykres liniowy',
    pie: 'Wykres kołowy',
    bar: 'Wykres słupkowy',
    table: 'Tabela danych',
  },
  datePicker: {
    startDate: 'Data początkowa',
    endDate: 'Data końcowa',
    lastWeek: '7 dni',
    lastTwoWeeks: '14 dni',
    lastSmallMonth: '28 dni',
    lastMonth: '30 dni',
    lastThreeMonths: '3 miesiące',
    lastSixMonths: '6 miesięcy',
    lastYear: 'rok',
  },
  chart: {
    noData: 'Brak danych',
    refresh: 'Odśwież wykres',
  },
  billing: {
    title: 'Dane do faktury',
    name: 'Nazwa',
    vatnr: 'NIP',
    phone: 'Numer telefonu',
    address: 'Adres',
    postcode: 'Kod pocztowy',
    city: 'Miasto',
    country: 'Kraj',
    success: 'Dane zaktualizowano pomyślnie',
    firstName: 'Imię',
    lastName: 'Nazwisko',
  },
  settings: {
    title: 'Ustawienia',
    changePasswordTitle: 'Zmiana hasła',
    changePassword: 'Zmień hasło',
    oldPassword: 'Aktualne hasło',
    password: 'Nowe hasło',
    repeatPassword: 'Powtórz hasło',
    changePasswordSuccess: 'Hasło zmienione',
    general: 'Ogólne',
    currency: 'Bazowa waluta',
    changeSuccess: 'Dane zmienione pomyślnie',
  },
  resetPassword: {
    title: 'Proszę wprowadzić swój adres e-mail, na który wysłany zostanie link do resetu hasła',
    backToLogin: 'Powrót do logowania',
    success: 'Na podany adres e-mail został wysłany link do resetu hasła',
    label: 'Wyślij',
    email: 'Adres e-mail',
    failure: 'Błąd podczas procesu resetu hasła, spróbuj ponownie',
    failureMsg: 'Błąd podczas procesu resetu hasła: {msg}',
  },
  setNewPassword: {
    title: 'Wprowadź nowe hasło',
    backToLogin: 'Powrót do logowania',
    success: 'Hasło zostało zmienione pomyślnie',
    label: 'Zmień hasło',
    password: 'Nowe hasło',
    confirmPassword: 'Powtórz nowe hasło',
    failure: 'Błąd podczas ustawiania nowego hasła, spróbuj ponownie',
    failureMsg: 'Błąd podczas ustawiania nowego hasła: {msg}',
  },
  selectAccount: {
    title: 'Proszę wprowadzić adres email klienta, na którego konto chcesz się zalogować',
    backToAccount: 'Przejdź do swojego konta',
    success: 'Konto zostało zmienione',
    label: 'Zaloguj',
    email: 'Adres e-mail',
    failure: 'Błąd podczas procesu logowania na konto klienta, spróbuj ponownie',
    failureMsg: 'Błąd podczas procesu logowania na konto klienta: {msg}',
  },
  dashboard: {
    title: 'Dashboard',
    paymentMethods: 'Wykorzystywane metody płatności',
    shippingMethods: 'Wykorzystywane metody dostawy',
    sessions: 'Sesje',
    users: 'Użytkownicy',
    transactionsCount: 'Liczba transakcji',
    failedTransactionCount: 'Nieudane',
    successTransactionCount: 'Udane',
    transactionsIncome: 'Przychód z transakcji',
    transactionsLost: 'Zysk utracony z transakcji',
    averageCartValue: 'Średnia wartość koszyka',
    chart: {
      total: 'Wszystkie',
    },
  },
  devices: {
    title: 'Urządzenia',
    addNew: 'Dodaj nowe urządzenie',
    phoneNumber: 'Numer telefonu',
    name: 'Nazwa',
    email: 'Email',
    deviceStatus: 'Status',
    deviceGroupList: 'Grupy urządzeń',
    active: 'Włączone',
    inactive: 'Wyłączone',
    activate: 'Włącz',
    pending: 'Oczekujące',
    disable: 'Wyłącz',
    changeStatusSuccess: 'Status urządzenia zmieniono pomyślnie',
    delete: 'Usuń',
    deleteSuccess: 'Urządzenie usunięto pomyślnie',
    deleteText: 'Ta operacja jest nieodwracalna! Czy chcesz kontynuować?',
    deleteTitle: 'Potwierdź usunięcie {email}',
    add: {
      title: 'Dodaj nowe urządzenie',
      phoneNumber: 'Numer telefonu',
      name: 'Nazwa',
      deviceGroups: 'Grupy urządzeń',
      deviceGroupsAdd: 'Podaj identyfikator grupy i wciśnij ENTER',
      success: 'Urządzenie dodano pomyślnie',
      email: 'Email',
    },
    summaryTitle: 'Urządzenia w subskrypcji:',
  },
  contact: {
    title: 'Kontakt',
    send: 'Wyślij',
    subject: 'Temat',
    message: 'Wiadomość',
    sendSuccess: 'Dziękujemy za kontakt - odezwiemy się możliwie jak najszybciej',
  },
  apiKeys: {
    title: 'Klucze API',
    addNew: 'Wygeneruj nowy klucz',
    id: 'ID',
    scope: 'Grupa uprawnień',
    created: 'Utworzono',
    apiKey: 'Klucz API',
    documentationLink: 'Dokumentacja API',
    apiKeyBelow: 'Poniżej znajduje się Twój klucz API',
    copyInfo: 'skopiuj go i zachowaj, bo nie będzie później możliwości jego ponownego wyświetlenia!',
    keyGeneratedTitle: 'Wygenerowano klucz API',
    masterAccountId: 'MasterAccountId',
    deleteSuccess: 'Pomyślnie usunięto klucz API'
  },
  wizard: {
    account: {
      name: 'Twoje imię',
      phoneNumber: 'Numer telefonu',
      email: 'Adres e-mail',
      domain: 'Nazwa domeny',
      lang: 'Język',
      password: 'Hasło',
      passwordInfo: 'Aby połączyć istniejące konto Labelcall z nową integracją, wprowadź hasło',
    },
    props: {
      title: 'Właściwości',
      description: 'Wybierz jakie informacje chcesz wyświetlać na telefonie, kiedy dzwoni klient. Możesz również dowolnie ustawić ich kolejność przeciągając belki',
    },
    next: 'Dalej',
    previous: 'Powrót',
    title: 'Uzupełnij dane.',
    step: 'Krok',
    accountSettings: 'Dane konta',
    propSettings: 'Konfiguracja pól',
    integrationAlreadyExists: 'Integracja już istnieje',
    createIntegrationError: 'Nie udało się utworzyć integracji. Spróbuj ponownie później',
    invalidPassword: 'Hasło nieprawidłowe',
    summary: 'Podsumowanie',
    registrationSuccessful: 'Rejestracja przebiegła pomyślnie!',
    thanks: 'Dziękujemy!',
    appDownloadHeader: 'Teraz możesz pobrać naszą aplikację na swój telefon komórkowy.',
    appDownload: 'Skorzystaj z linku poniżej lub użyj linku, który wysłaliśmy SMS-em na Twój telefon.',
    syncInProgress: 'Trwa synchronizacja',
    syncCompleted: 'Synchronizacja danych zakończona',
    syncAboutToStart: 'Synchronizacja danych zaraz się rozpocznie',
    end: 'Przejdź do panelu',
    loginToPortal: 'Przejdź do portalu',
    alreadyHaveAaAccount: 'Czy masz konto?',
    loginHere: 'Zaloguj się',
    dontHaveAccount: 'Nie masz konta?',
    registerHere: 'Zarejestruje się',
    forgotPassword: 'Zapomniałem hasło',
    resetPassword: 'Resetuj hasło',
    summaryGetMobileApp1: 'Użyj poniższego linku, aby pobrać aplikację na swój telefon. Następnie połącz się ze swoim kontem i możesz korzystać z aplikacji. Jeśli masz jakiś problem, skorzystaj z naszego ',
    summaryGetMobileApp2: 'poradnika',
    summaryGetMobileApp3: 'lub skontaktuj się z nami przez',
    summaryPassword: 'Hasło do panelu administratora zostało wysłane na podany wcześniej adres e-mail. ',
    summaryContact: 'Jeśli masz jakiś problem, skontaktuj się z nami',
    summarySynchronization1: 'Obecnie synchronizujemy Twoje dane historyczne z usługą Labelcall, może to zająć nawet godzinę.',
    summarySynchronization2: 'Nowi klienci synchronizują się natychmiast.',
    integrationLogo: 'Logo integracji',
    terms1: 'Klikając „Dalej”, zgadzam się z Labelcall',
    terms2: 'Zasady i Warunki',
    terms3: 'oraz',
    terms4: 'Politykę Prywatności',
    erecruiterInvalidAccessKey: 'Niepoprawny kod dostępu ERekruter',
    erecruiterAccessKeyUpdated: 'Zaktualizowano kod dostępu ERekruter',
    erecruiterAccountWithCompanyIdAlreadyExists: 'Dane konto z ERekruter jest już powiązane z kontem w Labelcall',
    traffitInvalidCredentials: 'Niepoprawne dane dostępowe Traffit',
    traffitCredentialsUpdated: 'Zaktualizowano dane dostępowe Traffit',
    traffitAccountAlreadyExists: 'To konto Traffit jest już powiązane z kontem w Labelcall',
    traffitConfig: 'Konfiguracja Traffit',
    traffitDescription: 'Wprowadź dane dostępowe API Traffit. Znajdziesz je w Traffit Ustawienia > Integracja.',
    apiloInvalidCredentials: "Niepoprawne dane dostępowe Apilo",
    apiloDescription: "Poniższe dane potrzebne sa do komunikacji z Apilo",
    apiloConfig: "Konfiguracja Apilo",
    apikeys: {
      header: 'Klucze API',
      description: 'Klucz API jest potrzebny do komunikacji z usługą w celu pobrania danych.',
      descriptionLink: 'Więcej informacji znajdziesz na stronie.',
      url: 'Url',
      apiKey: 'Klucz API',
      invalidApiKey: 'Niepoprawny klucz API'
    },
  },
  calls: {
    history: 'Historia połaczeń',
    phoneNumber: 'Numer telefonu',
    callType: 'Typ połączenia',
    dateTimeOfCall: 'Data',
    callDuration: 'Czas trwania',
    callStatus: 'Status',
    incoming: 'przychodzące',
    outgoing: 'wychodzące',
    received: 'odebrane',
    rejected: 'odrzucone',
    callsCount: 'Liczba połączeń:',
    lastCall: 'Ostatnie połączenie',
    totalDuration: 'Całkowity czas połączeń:',
    chartSummary: 'Czas trwania połączeń',
    wasRecognized: 'Czy rozpoznane?',
    true: 'tak',
    false: 'nie',
  },
  payments: {
    history: 'Historia płatności',
    subscriptionCode: 'Kod subskrypcji',
    allowedDevices: 'Ilość urządzeń',
    allowedCallsMonthly: 'Ilość połączeń miesięcznie',
    allowedCallsDaily: 'Ilość połączeń dziennie',
    allowedCallsDailyUnlimited: 'Nielimitowana',
    amount: 'Cena',
    status: 'Status',
    date: 'Data',
    refreshTable: 'Odśwież tabelę',
    action: 'Akcja',
    buy: 'Kup',
    extend: 'Przedłuż',
    unlimitedCallsMonthly: 'Nielimitowana',
    payment: {
      saveBillingInformations: 'Zapisz informacje billingowe',
      creditOrDebitCard: 'Karta kredytowa albo debetowa',
      pay: 'Zapłać',
      success: 'Płatność zakończona sukcesem, dziękujemy!',
      addNewCard: 'Dodaj nową kartę',
      selectCard: 'Wybierz kartę',
      selectCardError: 'Wybierz kartę lub dodaj nową',
      error: 'Płatność nie powiodła się, spróbuj ponownie później',
      shopifyInfo: 'Płatność będzie realizowana przez Shopify.',
      goToShopify: 'Przejdź do Shopify',
      shopifyRemovedIntegrationInfo: 'Twoje konto Labelcall nie jest już połączone z Shopify poprzez integrację z sklepem. Przejdź do Shopify, aby ponownie połączyć aplikację. ',
    },
  },
  integrations: {
    title: 'Integracje',
    type: 'Typ',
    domain: 'Domena',
    status: 'Status',
    refreshTable: 'Odśwież tabelę',
    action: 'Akcje',
    details: 'Szczegóły',
    dataLoadError: 'Błąd podczas ładowania danych, spróbuj ponownie później',
    addNextIntegration: 'Dodaj kolejną integrację',
    name: 'Nazwa',
    changeName: 'Zmień nazwę',
    deleteSuccess: 'Usunięto pomyślnie!',
    updateSuccess: 'Zaktualizowano pomyślnie!',
    activateSuccess: 'Aktywowano pomyślnie!',
    error: 'Wystąpił błąd!',
    deleteTitle: 'Potwierdź usunięcie integracji',
    integration: {
      title: 'Integracja',
      domain: 'Domena',
      type: 'Typ',
      apikey: 'Klucz API',
      status: 'Status',
      manualsync: 'Ręczna synchronizacja',
      sync: 'Synchronizuj',
      props: 'Właściwości',
      save: 'Zapisz',
      back: 'Powrót',
      syncStarted: 'Synchronizacja rozpoczęta',
      syncError: 'Synchronizacja nie powiodła się, spróbuj ponownie później',
      propsUpdatedSuccess: 'Aktualizacja ustawień zakończona sukcesem',
      propsUpdatedError: 'Aktualizacja ustawień niepowiodła się, spróbuj ponownie później',
      externalRemove: 'Brak możliwości usunięcia integracji z poziomu panelu, usuń integrację na: ',
      connect: 'Połącz ponownie',
    },
    delete: 'Usuń',
    activate: 'Aktywuj',
    statuses: {
      active: 'Aktywna',
      notcomplete: 'Nie skonfigurowana',
      suspended: 'Zawieszona',
      deleted: 'Usunięta',
      turnoff: 'Wyłączona',
      expired: 'Wygasła'
    }    
  },
  profile: {
    title: 'Profil',
    passwordChange: 'Zmień hasło',
    email: 'Email',
    name: 'Imię',
    accountName: 'Nazwa konta',
    language: 'Język',
    current_password: 'Aktualne hasło',
    new_password: 'Nowe hasło',
    new_password_confirm: 'Potwierdź nowe hasło',
    profileUpdateSuccess: 'Profil zaktualizowany pomyślnie',
    passwordChangeSuccess: 'Hasło zmienione pomyślnie',
    defaultPhoneNumberPrefix: 'Prefix numeru',
  },
  plan: {
    yourSubtitle: 'Twoja subskrypcja',
    currentSubscription1: 'Twoja aktualna subskrypcja to ',
    currentSubscription2: ' i kończy się ',
    noSubscription: 'Nie posiadasz żadnej subskrypcji',
    title: 'Plany abonamentowe',
    plans: {
      lc_basic: 'Podstawowy',
      lc_advance: 'Zaawansowany',
      lc_premium: 'Premium',
      lc_basic_yearly: 'Podstawowy',
      lc_advance_yearly: 'Zaawansowany',
      lc_premium_yearly: 'Premium',
      free10: 'Freemium',
    },
    allowedDevicesUnlimited: 'Nielimitowana ilość urządzeń',
    allowedCallsDailyUnlimited: 'Nielimitowana liczba połączeń',
    allowedContactsUnlimited: 'Nielimitowana liczba kontaktów',
    allowedDevices: '{n} urządzenie | {n} urządzeń',
    allowedCallsDaily: '{n} połączeń dziennie',
    allowedCallsMonthly: '{n} połączeń miesięcznie',
    allowedContacts: '{n} kontaktów',
    responseTimeGuarantee: 'Gwarancja czasu odpowiedzi',
    labelcallApiAccess: 'Dostęp do API labelcall',
    buy: 'Kup teraz',
    perMonth: 'miesięcznie',
    perYear: 'rocznie',
    writeToUs: 'Napisz do nas na contact@labelcall.com',
    individualOffer: 'Indywidualnie ustalana oferta',
    cancelSubscription: 'Zmień wersję na bezpłatną',
    cancel: 'Anuluj',
    cancelSubMsg: 'Jeśli subskrypcja zostanie anulowana to po zakończniu okresu jej trwania, nie zostanie ona przedłużona. Te operacja jest nieodwracalna!',
    subscriptionCancelSuccess: 'Subskrypcja anulowana pomyślnie',
    subscriptionCancelError: 'Anulowanie subskrypcji nie powiodło się, spróbuj ponownie później',
    subCancalled: 'Subskrypcja anulowana',
    free: 'Darmowy',
    changingSubscription: 'Trwa zmiana subskrypcji...',
    shopifyInformation: 'i jest obsługiwana przez Shopify. Po więcej informacji udaj się panelu Shopify.',
    showYearlyDuration: 'Pokaż roczne plany',
    changePlanWarining: 'Zmiana planu może spowodować dezaktywację urządzeń.',
  },
  properties: {
    noProps: 'Brak dostępnych właściwości - utwórz integrację, by dodać kilka z nich',
    selectSource: 'Wybierz źródło',
    isActive: 'Czy pole jest aktywne',
    propertyOrigin: 'Źródło właściwości',
    origin: {
      custom: 'własna',
    },
  },
  paymentSettings: {
    title: 'Ustawienia płatności',
    addNew: 'Dodaj nową kartę',
    brand: 'Marka',
    last4: 'Numer karty',
    setAsDefault: 'Ustaw jako domyślną',
    delete: 'Usuń',
    expDate: 'Data ważności',
    default: 'Domyślna',
    deleteCardMsg: 'Ta operacja jest nieodwracalna! Czy chcesz kontynuować?',
    cancel: 'Anuluj',
    deleteCard: 'Usuń kartę',
    cardDeleteSuccess: 'Usuwanie karty zakończone sukcesem',
    cardDeleteError: 'Usuwanie karty nie powiodło się, spróbuj ponownie później',
    tableDataLoadingError: 'Pobieranie listy kart nie powiodło się, spróbuj ponownie później',
    cardSetAsDefaultSuccess: 'Ustawienie karty jako domyślnej zakończone sukcesem',
    cardSetAsDefaultError: 'Ustawienie karty jako domyślnej nie powiodło się, spróbuj ponownie później',
    addCard: 'Dodaj kartę',
    addCardSuccess: 'Dodanie karty powiodło się',
    addCardError: 'Dodawanie karty nie powiodło się, spróbuj ponownie później',
    cannotDeleteDefaultCard: 'Nie można usunąć domyślnej karty jeśli subskrypcja jest aktywna',
  },
  invoices: {
    history: 'Historia płatności',
    subscriptionCode: 'Kod subskrypcji',
    amount: 'Cena',
    status: 'Status',
    date: 'Data',
    refreshTable: 'Odśwież tabelę',
    invoicePdf: 'Faktura PDF',
    downloadPdf: 'Pobierz',
  },
  searchContact: {
    title: 'Wyszukaj kontakt',
    search: 'Szukaj',
    noRecord: 'Brak kontaktu',
    propertyName: 'Nazwa właściwości',
    value: 'Wartość',
    phoneNumber: 'Numer telefonu',
    or: 'Lub',
    source: 'Źródło',
    dateCreated: 'Data utworzenia',
    dateModified: 'Data modyfikacji',
    open: 'Otwórz',
    chooseIntegration: 'Wybierz integracje',
  },
  stepTracker:{
    installApp: "1. Zainstaluj aplikację",
    appInstalled: "1. Zainstalowano aplikację",
    installAppContent: "Pobierz aplikację na swój telefon, aby móc połączyć się ze swoją platformą.",
    appInstalledContent: "Jesteś na dobrej drodze! Teraz wystarczy, że połączysz się ze swoją platformą.",
    integrateShop: "2. Połącz się ze swoim sklepem",
    shopIntegrated: "2. Połączono ze sklepem",
    integrateShopContent: "W zakładce \"Integracje\" zintegruj się ze swoją platformą. Możesz też to zrobić z poziomu swojego telefonu.",
    shopIntegratedContent: "Brawo! Możesz już w pełni korzystać z naszej aplikacji :-)",
    button: "Integracje"
  },
  ...plLocale,
};
